import Vue from 'vue';

// js安全乘法
Vue.prototype.$jsSafeAccumulate = (arg1, arg2) => {
  let m = 0;
  const s1 = arg1.toString();
  const s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {
    // TODO
  }
  try {
    m += s2.split('.')[1].length;
  } catch (e) {
    // TODO
  }
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / (10 ** m);
}

// js安全除法
Vue.prototype.$jsSafeAccdiv = (arg1, arg2) => {
  let t1 = 0;
  let t2 = 0;
  try {
    t1 = arg1.toString().split('.')[1].length
  } catch (e) {
    // TODO
  }
  try {
    t2 = arg2.toString().split('.')[1].length
  } catch (e) {
    // TODO
  }
  const r1 = Number((typeof arg1 === 'number' ? arg1 : 0).toString().replace('.', ''));
  const r2 = Number((typeof arg2 === 'number' ? arg2 : 0).toString().replace('.', ''));
  return (r1 / r2) * (10 ** (t2 - t1));
}

Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1, //month
    "d+": this.getDate(), //day
    "h+": this.getHours(), //hour
    "m+": this.getMinutes(), //minute
    "s+": this.getSeconds(), //second
    "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
    "S": this.getMilliseconds() //millisecond
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }

  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
}


